module.exports = __webpack_public_path__ + "fontawesome-webfont.97493d3f11c0a3bd5cbd.woff2";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/fontawesome/fontawesome-webfont.woff2?v=4.3.0
// module id = ../../../../../src/assets/css/fonts/fontawesome/fontawesome-webfont.woff2?v=4.3.0
// module chunks = 2